export default __webpack_public_path__ + "fonts/demographics_commute_icon.svg";